import { ReservationApiModel } from '@era/inroom-sdk';
import { Action } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';

export enum MobileReservationActionTypes {
  // Resolver
  MOBILE_RESERVATION_RESOLVER_MOBILE_RESERVATIONS_REQUESTED = '[Mobile reservation resolver] Mobile reservations requested',

  MOBILE_RESERVATION_GUEST_MODAL_CONFIRMED = '[Mobile reservation] Guest modal confirmed',

  MOBILE_RESERVATION_SIGNALR_STATE_CHANGED = '[Mobile reservation signalR] State changed',

  // API
  MOBILE_RESERVATION_API_MOBILE_RESERVATIONS_LOADED = '[Mobile reservation API] Mobile reservations loaded',
  MOBILE_RESERVATION_API_MOBILE_RESERVATIONS_LOADED_ERROR = '[Mobile reservation API] Mobile reservations loaded error',
  MOBILE_RESERVATION_API_MOBILE_RESERVATION_DELETED = '[Mobile reservation API] Mobile reservation deleted',
  MOBILE_RESERVATION_API_MOBILE_RESERVATION_DELETED_ERROR = '[Mobile reservation API] Mobile reservation deleted error',
  MOBILE_RESERVATION_API_MOBILE_RESERVATION_UPDATED = '[Mobile reservation API] Mobile reservation updated',
  MOBILE_RESERVATION_API_MOBILE_RESERVATION_UPDATED_ERROR = '[Mobile reservation API] Mobile reservation updated error',
}

export class MobileReservationResolverMobileReservationsRequested implements Action {
  readonly type = MobileReservationActionTypes.MOBILE_RESERVATION_RESOLVER_MOBILE_RESERVATIONS_REQUESTED;

  constructor(public payload: { hotelCode: string; unitCode: string }) {}
}

export class MobileReservationGuestModalConfirmed implements Action {
  readonly type = MobileReservationActionTypes.MOBILE_RESERVATION_GUEST_MODAL_CONFIRMED;

  constructor(public payload: { mobileReservation: ReservationApiModel }) {}
}

// API
export class MobileReservationApiMobileReservationsLoaded implements Action {
  readonly type = MobileReservationActionTypes.MOBILE_RESERVATION_API_MOBILE_RESERVATIONS_LOADED;

  constructor(public payload: { mobileReservations: ReservationApiModel[] }) {}
}

export class MobileReservationApiMobileReservationsLoadedError implements Action {
  readonly type = MobileReservationActionTypes.MOBILE_RESERVATION_API_MOBILE_RESERVATIONS_LOADED_ERROR;

  constructor(public payload: { error: ErrorModel }) {}
}

export class MobileReservationApiMobileReservationDeleted implements Action {
  readonly type = MobileReservationActionTypes.MOBILE_RESERVATION_API_MOBILE_RESERVATION_DELETED;

  constructor(public payload: { mobileReservation: ReservationApiModel }) {}
}

export class MobileReservationApiMobileReservationDeletedError implements Action {
  readonly type = MobileReservationActionTypes.MOBILE_RESERVATION_API_MOBILE_RESERVATION_DELETED_ERROR;

  constructor(public payload: { mobileReservation: ReservationApiModel; error: ErrorModel }) {}
}

export class MobileReservationApiMobileReservationUpdated implements Action {
  readonly type = MobileReservationActionTypes.MOBILE_RESERVATION_API_MOBILE_RESERVATION_UPDATED;

  constructor(public payload: { mobileReservation: ReservationApiModel }) {}
}

export class MobileReservationApiMobileReservationUpdatedError implements Action {
  readonly type = MobileReservationActionTypes.MOBILE_RESERVATION_API_MOBILE_RESERVATION_UPDATED_ERROR;

  constructor(
    public payload: {
      originalMobileReservation: ReservationApiModel;
      mobileReservation: ReservationApiModel;
      error: ErrorModel;
    }
  ) {}
}

export class MobileReservationSignalRStateChanged implements Action {
  readonly type = MobileReservationActionTypes.MOBILE_RESERVATION_SIGNALR_STATE_CHANGED;

  constructor(public payload: { mobileReservation: ReservationApiModel }) {}
}

export type MobileReservationsActionUnion =
  | MobileReservationResolverMobileReservationsRequested
  | MobileReservationGuestModalConfirmed
  | MobileReservationSignalRStateChanged
  // API
  | MobileReservationApiMobileReservationsLoaded
  | MobileReservationApiMobileReservationsLoadedError
  | MobileReservationApiMobileReservationUpdated
  | MobileReservationApiMobileReservationUpdatedError
  | MobileReservationApiMobileReservationDeleted
  | MobileReservationApiMobileReservationDeletedError;
